import React from 'react';

const VerticalBar = ({ barPercentage,textPercentage, imageSource, altText }) => {
  console.log(barPercentage,textPercentage, );
  return (
   
    <div className="flex flex-col items-center justify-between bg-gray-gradient rounded-full py-[5px] px-1"
    
    style={{ height:barPercentage}}>
      <div className='text-[8px] w-[18px] text-center  text-[#505D6F] font-normal'>{textPercentage}</div>
      <img src={imageSource} className='w-[30px]' alt={altText} />
    </div>
  );
}

export default VerticalBar;
